import axios from 'axios';

export const fileService = {
    getFilesService: (params) => axios.get(`/documents/${params?.model}/${params?.id}`, { auth: true, params: params?.reqParams }),

    addFileService: (params, body) => axios.post(`/documents/${params?.model}/${params?.id}`, body, { auth: true }),

    editFileService: (params, id, body) => axios.patch(`/documents/${params?.model}/${params?.id}/${id}`, body, { auth: true }),

    deleteFilesService: (params, docIds) => axios.delete(`/documents/${params?.model}/${params?.id}`, { auth: true, data: docIds }),

    archiveFilesService: (params, docIds) => axios.patch(`/documents/${params?.model}/${params?.id}/archive`, docIds, { auth: true }),

    shareFileService: (resourceId, fileId, body) => axios.post(`/client/${resourceId}/documents/${fileId}/share`, body, { auth: true }),

    unShareFileService: (resourceId, fileId) => axios.post(`/client/${resourceId}/documents/${fileId}/unshare`, {}, { auth: true }),
};
